import React, { ReactNode, useState } from "react";

interface TooltipProps {
    text: string;
    children: ReactNode;
}

const Tooltip: React.FC<TooltipProps> = ({ text, children }) => {
    const [isVisible, setIsVisible] = useState(false);

    return (
        <div
            className="relative flex items-center"
            onMouseEnter={() => setIsVisible(true)}
            onMouseLeave={() => setIsVisible(false)}
        >
            {children}
            {isVisible && (
                <div
                    className="absolute max-w-60 z-40 top-full left-1/2 transform -translate-x-1/2 mt-2 w-max bg-gray-800 text-white text-xs 2xl:text-sm p-3 rounded-lg shadow-lg opacity-100 transition-opacity duration-300"
                    dangerouslySetInnerHTML={{ __html: text }} // Enables HTML rendering
                />
            )}
        </div>
    );
};

export default Tooltip;
